import {
    getCharMaxMessage,
    getCharMinMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const NOTE_MAX_CHAR = 750;
export const NOTE_MIN_CHAR = 5;

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.statusId.length) {
        newErrors = {
            ...newErrors,
            statusId: { error: true, message: getSelectMessage('Status') }
        };
    }

    if (newEntry.notes && newEntry.notes?.trim().length < NOTE_MIN_CHAR) {
        newErrors = {
            ...newErrors,
            notes: { error: true, message: getCharMinMessage('Notes', NOTE_MIN_CHAR) }
        };
    } else if (newEntry.notes.length > NOTE_MAX_CHAR) {
        newErrors = {
            ...newErrors,
            notes: { error: true, message: getCharMaxMessage('Notes', NOTE_MAX_CHAR) }
        };
    }

    return newErrors;
};
